import { COLORS } from '../utils/colors';
import { siteContent } from '../content';
import { LogoWithText } from './Logo';
import { StatCard } from './Card';

export const Hero = ({ isVisible, scrollToSection }) => (
  <section id="hero" className="relative min-h-screen flex items-center justify-center pt-16 overflow-hidden" style={{ backgroundColor: 'white' }}>
    <div className="absolute inset-0" style={{ 
      background: 'linear-gradient(135deg, #FFF7F0 0%, #F0FDFA 50%, #F8FAFC 100%)'
    }}></div>
    
    <div className="absolute top-20 right-10 w-64 h-64 rounded-full opacity-20" style={{ background: `radial-gradient(circle, ${COLORS.cantaloupe}40, transparent)` }}></div>
    <div className="absolute bottom-20 left-10 w-48 h-48 rounded-full opacity-20" style={{ background: `radial-gradient(circle, ${COLORS.teal}40, transparent)` }}></div>

    <div className="relative z-10 text-center max-w-5xl mx-auto px-6">
      <div className={`transform transition-all duration-1000 ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
        <div className="flex justify-center mb-12">
          <LogoWithText dark={false} />
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold mb-8 leading-tight">
          <span style={{ color: COLORS.navy }}>{siteContent.hero.headline1}</span>
          <br />
          <span style={{ background: `linear-gradient(to right, ${COLORS.cantaloupe}, ${COLORS.teal})`, WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            {siteContent.hero.headline2}
          </span>
        </h1>

        <p className="text-xl md:text-2xl mb-4 max-w-3xl mx-auto leading-relaxed" style={{ color: COLORS.slate }}>
          {siteContent.hero.subtitle}
        </p>
        
        <p className="text-lg mb-12" style={{ color: '#94A3B8' }}>
          {siteContent.company.location}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 max-w-4xl mx-auto">
          {siteContent.hero.metrics.map((metric, index) => (
            <StatCard key={metric.label} value={metric.value} label={metric.label} colorIndex={index} dark={false} />
          ))}
        </div>

        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          <button 
            className="text-lg px-10 py-4 rounded-xl font-semibold transform transition-all duration-300 hover:scale-105 text-white"
            style={{ background: `linear-gradient(to right, ${COLORS.cantaloupe}, ${COLORS.cantaloupeDark})`, boxShadow: '0 4px 20px rgba(255,130,67,0.3)' }}
            onClick={() => scrollToSection('contact')}
          >
            {siteContent.hero.ctaPrimary}
          </button>
          <button 
            className="text-lg px-10 py-4 rounded-xl font-semibold transform transition-all duration-300 hover:scale-105"
            style={{ backgroundColor: 'white', border: `2px solid ${COLORS.teal}`, color: COLORS.navy }}
            onClick={() => scrollToSection('stories')}
          >
            {siteContent.hero.ctaSecondary}
          </button>
        </div>

        <div className="mt-16 flex flex-wrap justify-center items-center gap-8 text-sm" style={{ color: COLORS.slate }}>
          {siteContent.hero.trustIndicators.map((indicator, index) => (
            <div key={index} className="flex items-center space-x-2">
              <span className="w-2 h-2 rounded-full" style={{ backgroundColor: COLORS.teal }}></span>
              <span>{indicator}</span>
            </div>
          ))}
        </div>
      </div>
    </div>

    <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
      <div className="w-6 h-10 rounded-full flex justify-center" style={{ border: `2px solid ${COLORS.cantaloupe}` }}>
        <div className="w-1 h-3 rounded-full mt-2 animate-pulse" style={{ backgroundColor: COLORS.cantaloupe }}></div>
      </div>
    </div>
  </section>
);
